<template>
	<div id="root-list-matching">
		<b-overlay
				id="asd"
				:show="queryInProgress"
				variant="light"
				opacity="0.5"
				blur="2px"
				rounded="lg"
		><!-- overlay -->
			<b-card id="main-card-list-matching">
				<div class="d-flex">
					<div class="p-2"><h3>Listenabgleich</h3></div>
					<div class="ml-auto p-2">
						<b-btn id="info-modal" size="sm" @click="showInfoModal = !showInfoModal">
							<b-icon icon="info-lg"></b-icon>
						</b-btn>
					</div>
				</div>
				<div>
					<b-form inline class="py-2">
						<label class="mr-2 col-3 text-right">Listen Typ:</label>
						<b-form-select
								v-model="select.listType"
								:options="listTypeOptions"
								size="sm"
								@input="() => {}"
								class="inputsf"
						></b-form-select>
					</b-form>
					<!-- asd -->
					<b-form
							v-show="listRequiresVendorSelectionInput"
							inline
							class="py-2"
					>
						<label class="mr-2 col-3 text-right" for="select-vendors">Lieferanten:</label>
						<pv-multi-select
								id="select-vendors"
								v-model="selectedVendors"
								filter
								display="chip"
								:options="(wantMainVendorOnly ? mainVendorOptions : allVendorOptions)"
								optionLabel="text"
								optionValue="value"
								placeholder="wähle Händler"
						>
						</pv-multi-select>
						<b-form-checkbox
								class="ml-2"
								v-model="wantMainVendorOnly"
								name="checkbox-1"
								:value="true"
								:unchecked-value="false"
						>nur Hauptlieferanten
						</b-form-checkbox>
					</b-form>
					<b-form v-if="listRequiresDatePickerInput" inline class="py-2">
						<label for="datepicker" class="mr-2 col-3 text-right ">Zeitraum:</label>
						<div id="datepicker" class="d-flex">
							<label for="select-date-range-from" class="mr-2 text-right col-3">von</label>
							<b-form-datepicker
									id="date-range-from"
									class="mb-2 col-6"
									size="sm"
									:state="validateDateRange"
									v-model="dateFrom"
									:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
							</b-form-datepicker>

							<label for="select-date-range-to" class="mr-2 col-3 text-right">bis</label>
							<b-form-datepicker
									id="date-range-to"
									class="mb-2 col-6"
									size="sm"
									:state="validateDateRange"
									v-model="dateTo"
									:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
							</b-form-datepicker>
						</div>
					</b-form>
					<!--if only one date is requiered and not a date range-->
					<b-form v-if="listRequiresSingleDatePickerInput" inline class="py-2">
						<label for="datepicker" class="mr-2 col-3 text-right ">Zeitraum:</label>
						<div id="datepicker" class="d-flex">
							<label for="select-date-range-from" class="mr-2 text-right col-3" style="min-width: 157px">ab dem</label>
							<b-form-datepicker
									id="date-range-from"
									class="mb-2 col-6"
									size="sm"
									:state="validateDateRange"
									v-model="dateFrom"
									:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
							</b-form-datepicker>
						</div>
					</b-form>
					<b-form inline class="py-2">
						<label class="mr-2 col-3 text-right">Barcodes:</label>
						<b-textarea
								rows="18"
								size="sm"
								class="mr-1 inputsf"
								v-model="select.barcodes"
								@input="() => {}"
						/>
					</b-form>
					<div class="py-2">
						<b-button @click="submit()" :disabled="disableSendButton" class="float-right">absenden
							<b-spinner v-if="queryInProgress" variant="light" label="Spinning"></b-spinner>
						</b-button>
					</div>
				</div>
			</b-card>
		</b-overlay>
		<b-modal v-model="showInfoModal" title="Infos zu den Listenabgleichen">
			<div>
				<ul>
					<li><b>MarketOrderId / Sendungsnummer zu CustomerOrder/Address</b></li>
					Gibt Kunden- und Bestelldaten zu MarketOrderId oder Sendungsnummer aus.<br>
					Benötigt eine einfache Liste von MarketOrderIds oder Sendungsnummern.
					<li><b>Verkaufshäufigkeit</b></li>
					Gibt Verkaufshäufigkeit zu EANs und von den Lieferanten mit Bestand sofern vorhanden.<br>
					Alternativ wird der günstigste mit Bestand ausgegeben.<br>
					Benötigt eine einfache Liste von EANs, eine Auswahl von Lieferanten und Zeitraum Angaben.
					<li><b>LF, EAN Inventory / (Used)</b></li>
					Gibt Bestandsdaten zu EANs aus. Entweder für neuen oder gebrauchten Zustand.<br>
					Benötigt eine Liste mit tab-getrennten Lieferanten-Ids und EANs.
					<li><b>Inventory LF-Auswahl (EAN) / (Used)</b></li>
					Gibt Bestandsdaten zu EANs aus. Entweder für neuen oder gebrauchten Zustand.<br>
					Benötigt eine einfache Liste von EANs und eine Auswahl von Lieferanten.
					<li><b>Günstigster mit / Ohne Bestand</b></li>
					Gibt Bestandsdaten zu EANs aus, welche die günstigste Summe aus Einkaufs- und Versandpreis haben.<br>
					Mit oder ohne Lagerbestand.<br>
					Benötigt eine einfache Liste von EANs und eine Auswahl von Lieferanten.
					<li><b>Günstigster mit / Ohne Bestand (Alle LF)</b></li>
					Funktionsweise wie "Günstigster mit Bestand", jedoch für alle Lieferanten.<br>
					<li><b>Letzter VK-Preis (EAN)</b></li>
					Gibt den letzten Verkaufspreis zu EANs aus. Wahlweise nur für einen, mehrere oder alle Lieferanten.<br>
					Benötigt eine einfache Liste von EANs.<br>
					Wenn kein Lieferant ausgewählt wird, wird automatisch für alle Lieferanten gesucht.
					<li><b>Gewicht (EAN) / Gewicht (ASIN)</b></li>
					Gibt Produktdaten inklusive Gewicht in Kilogramm zu EAN oder ASIN aus.<br>
					Benötigt eine einfache Liste von EANs oder ASINs.
				</ul>
			</div>
			<template #modal-footer>
				<b-button variant="secondary" @click="showInfoModal = false">Schließen</b-button>
			</template>
		</b-modal>
		<modal-error-component v-model="modalError"></modal-error-component>
	</div>
</template>
<style scoped>
.inputsf {
	min-width: 70% !important;
}

.p-component {
	font-size: small !important;
}

.p-multiselect-label-container {
	max-width: 550px !important;
}

.max-width {
	max-width: 550px !important;
}

.p-multiselect {
	min-width: 589px !important;
}

.p-multiselect .p-multiselect-label {
	max-height: 30px !important;
}

.p-multiselect.p-multiselect-chip .p-multiselect-token {
	padding: 0.05rem 0.5rem !important;
}
</style>
<script>
import 'json2xls-xml';

export default {
	props: [],
	data() {
		return {
			popoverShow: false,
			queryInProgress: false,
			j2xls: require('json2xls-xml')({pretty: true}),
			select: {listType: "marketOrderIdToCustomerOrder", barcodes: "", vendorId: null},
			listTypeOptions: [
				{value: "marketOrderIdToCustomerOrder", text: "MarketOrderId zu CustomerOrder/Address"},
				{value: "shippingIdToCustomerOrder", text: "Sendungsnummer zu CustomerOrder/Address"},
				{value: "salesInvoices", text: "Ausgangsrechnungen"},
				{value: "getLastSellingPrice", text: "Letzter VK-Preis (EAN)"},
				{value: "quantityOfSales", text: "Verkaufshäufigkeit"},
				{value: "inventoryByEan", text: "LF, EAN Inventory"},
				{value: "inventoryByEanUsed", text: "LF, EAN Inventory (Used)"},
				{value: "inventoryByEanSelectVendor", text: "Inventory LF-Auswahl (EAN)"},
				{value: "inventoryByEanUsedSelectVendor", text: "Inventory LF-Auswahl (EAN, Used)"},
				{value: "cheapestWithStock", text: "Günstigster mit Bestand"},
				{value: "cheapestWithStock_AllVendors", text: "Günstigster mit Bestand (Alle LF)"},
				{value: "cheapestWithoutStock", text: "Günstigster ohne Bestand"},
				{value: "cheapestWithoutStock_AllVendors", text: "Günstigster ohne Bestand (Alle LF)"},
				{value: "weightByEan", text: "Gewicht (EAN)"},
				{value: "weightByAsin", text: "Gewicht (Asin)"},
				{value: "returnApplication", text: "Retourenantrag"},
			],
			vendors: null,
			selectedVendors: [],
			selectedStorageVendors: [],
			mainVendors: [],
			dateFrom: null,
			dateTo: null,
			wantMainVendorOnly: false,
			showInfoModal: false,
			modalError: {
				show: false,
				message: "unpopulated",
				error: "unpopulated",
				title: "unpopulated"
			},
		};
	},
	computed: {
		allVendorOptions: function () {
			if (!this.vendors) return [];
			return this.vendors.map(vendor => {
				return {value: vendor.id, text: `${vendor.name} - (${vendor.skuPrefix})`} //
			});
		},
		mainVendorOptions: function () {
			if (!this.mainVendors) return [];
			if (!this.vendors) return [];
			this.mainVendors = this.vendors.filter(vendor => vendor.mainVendorId === null)
			return this.mainVendors.map(vendor => {
				return {value: vendor.id, text: `${vendor.name} - (${vendor.skuPrefix})`} //
			});
		},
		validateDateRange: function () {
			if (!this.dateFrom || !this.dateTo) return;
			const from = Date.parse(this.dateFrom);
			const to = Date.parse(this.dateTo);
			return from <= to;
		},

		listRequiresVendorSelectionInput() {
			switch (this.select.listType) {
				case "getLastSellingPrice"            :
					return true;
				case "quantityOfSales"  							:
					return true;
				case "inventoryByEanSelectVendor"     :
					return true;
				case "inventoryByEanUsedSelectVendor" :
					return true;
				case "cheapestWithStock"              :
					return true;
				case "cheapestWithoutStock"           :
					return true;
				case "returnApplication"              :
					return true;
				default                               :
					return false;
			}
		},
		listRequiresDatePickerInput() {
			switch (this.select.listType) {
				case "quantityOfSales"                 :
					return true;
				default                                :
					return false;
			}
		},
		listRequiresSingleDatePickerInput() {
			switch (this.select.listType) {
				case "returnApplication"                 :
					return true;
				default                                :
					return false;
			}
		},
		disableSendButton() {
			if (this.select.barcodes.length === 0) return true;
			if (this.listRequiresVendorSelectionInput && this.selectedVendors.length === 0) return true;
			if (this.listRequiresDatePickerInput && (!this.dateFrom && !this.dateTo)) return true;
		}
	},
	methods: {

		getAllVendors() {
			this.queryInProgress = true;
			axios.get('/vendor/all').then(response => {
				this.queryInProgress = false;
				// console.log(response);
				this.vendors = response.data;
			}).catch(error => {
				this.queryInProgress = false;
				alert('Lieferantendaten konnten nicht vom Server runtergeladen werden.');
				console.error(error);
			});
		},

		//submitAction_getInventory
		//1. Boolean = articleCondition -- true = new / false = used
		//2. Boolean = onStock -- true = only stock.quantity > 0 / false = quantity = 0 / null = quantity does not matter
		//3. Boolean = vendorSelected -- true = vendor(s) were selected via multiselect / false for tab-divided VendorId and Ean
		//4. Boolean = allVendors -- if a list type requires the inventory of all vendors
		//submitAction_getShippingWeight
		//true = with ean / false = with asin
		submit() {
			switch (this.select.listType) {
				case "marketOrderIdToCustomerOrder"     :
					this.submitAction_marketOrderIdToCustomerOrder();
					break;
				case "shippingIdToCustomerOrder"        :
					this.submitAction_shippingIdToCustomerOrder();
					break;
				case "salesInvoices"                     :
					this.submitAction_salesInvoices();
					break;
				case "quantityOfSales"                  :
					this.submitAction_quantityOfSales();
					break;
				case "getLastSellingPrice"              :
					this.submitAction_getLastSellingPrice();
					break;
				case "inventoryByEan"                   :
					this.submitAction_getInventory(true, null, false, false);
					break;
				case "inventoryByEanUsed"               :
					this.submitAction_getInventory(false, null, false, false);
					break;
				case "inventoryByEanSelectVendor"       :
					this.submitAction_getInventory(true, null, true, false);
					break;
				case "inventoryByEanUsedSelectVendor"   :
					this.submitAction_getInventory(false, null, true, false);
					break;
				case "cheapestWithStock"                :
					this.submitAction_getCheapestStock(true, true, true, false);
					break;
				case "cheapestWithStock_AllVendors"     :
					this.submitAction_getCheapestStock(true, true, false, true);
					break;
				case "cheapestWithoutStock"             :
					this.submitAction_getCheapestStock(true, false, true, false);
					break;
				case "cheapestWithoutStock_AllVendors"  :
					this.submitAction_getCheapestStock(true, false, false, true);
					break;
				case "weightByEan"                      :
					this.submitAction_getShippingWeight(true);
					break;
				case "weightByAsin"                     :
					this.submitAction_getShippingWeight(false);
					break;
				case "returnApplication"                     :
					this.submitAction_ReturnApplication(false);
					break;
				default                                 :
					alert(`unknown listType action: ${this.select.listType}`);
			}
		},

		//marketOrderIds
		submitAction_marketOrderIdToCustomerOrder() {
			const marketOrderIds = this.extractIds();
			axios.post("/listmatching/action/marketorderid_to_customerorder", {marketOrderIds})
					.then(response => {
						const customerOrders = response.data;
						const mappedOrders = this.mapCustomerOrderData(customerOrders)
						const sortedOrders = this.sortData(marketOrderIds, mappedOrders, 'Bestell-ID');
						this.generateExcelFile(sortedOrders, 'Kundendaten');
						this.queryInProgress = false;
					}).catch(error => {
				this.showError(error)
				console.error(error);
				this.queryInProgress = false;
			});

		},

		//shippingId
		submitAction_shippingIdToCustomerOrder() {
			const shippingIds = this.extractIds();
			const request = {shippingIds: shippingIds}
			axios.post('/listmatching/action/shippingid_to_customerorder', request)
					.then(response => {

						const customerOrders = response.data;
						const mappedOrders = this.mapCustomerOrderData(customerOrders)
						const sortedOrders = this.sortData(shippingIds, mappedOrders, 'Sendungsnummer');
						this.generateExcelFile(sortedOrders, 'Kundendaten');
						this.queryInProgress = false;

					}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error);
			})
		},

		//salesInvoice
		submitAction_salesInvoices() {
			const marketOrderIds = this.extractIds();
			axios.post('/listmatching/action/sales_invoices', marketOrderIds, {
				responseType: 'blob'
			})
					.then(response => {
						const blob = response.data;
						const url = window.URL.createObjectURL(blob);

						const link = document.createElement('a');
						link.href = url;
						const date = moment().format('YYYY-MM-DD');
						link.download = `invoices_${date}.zip`;
						link.click();

						window.URL.revokeObjectURL(url);
						this.queryInProgress = false;
					}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error);
			})
		},

		//articleCondition -- true = new / false = used / null = all
		//onStock -- true = only stock.quantity > 0 / false = only stock.quantity = 0 / null quantity does not matter
		//vendorSelected -- true if vendor(s) were selected / false for tab-divided VendorId and Ean
		//allVendors -- if a list type requires the inventory of all vendors
		submitAction_getInventory(articleCondition, onStock, vendorsSelected, allVendors) {
			const vendorIdBarcodePair = this.extractIds()
			let vendorIds = [];
			const extractedBarcodes = [];
			//logic for tab divided VendorId and Ean
			if (vendorsSelected === false && allVendors === false) {
				for (const row of vendorIdBarcodePair) {
					let dump = row.split("\t");
					extractedBarcodes.push(dump[1]);

					if (dump == "") continue;
					if (dump.length != 2) {
						alert("Haendler-Id und Barcode muessen in jeder Zeile durch ein Tab-Zeichen getrennt werden. Fehlerhafte Zeile: \"" + row + "\"");
						return;
					}

					if (isNaN(dump[0])) {
						alert("Ihre Datenliste enthaelt einen Eintrag, wo der Haendler-Id keine Zahl ist:" + dump[0]);
						return;
					}
					if (isNaN(dump[1])) {
						alert("Ihre Datenliste enthaelt einen Eintrag, wo der EAN keine Zahl ist." + dump[1]);
						return;
					}
				}
			} else {
				if (allVendors === true) {
					vendorIds = this.vendors.filter(vendor => vendor.id !== 99 && vendor.id !== 199 && vendor.id !== 10000).map(vendor => {
						return vendor.id
					})
					vendorIds = vendorIds.sort((a, b) => a - b);
				} else {
					//cloneDeep because then its just a reference and selectedVendors shows subvendors
					vendorIds = _.cloneDeep(this.selectedVendors);
					vendorIds.forEach(id => {
						let tempIds = this.vendors.filter(vendor => vendor.mainVendorId === id).map(vendor => {
							return vendor.id
						});
						tempIds.forEach(tempId => {
							vendorIds.push(tempId);
						})
					})
					vendorIds = vendorIds.sort((a, b) => a - b);
				}
			}

			//convert the Article condition
			if (articleCondition === true) {
				articleCondition = 1;
			} else if (articleCondition === false) {
				articleCondition = 2;
			} else {
				articleCondition = null;
			}

			let request = {
				barcodes: vendorIdBarcodePair,
				vendorIds: vendorIds,
				articleCondition: articleCondition,
				onStock: onStock,
			}

			this.queryInProgress = true;
			axios.post("/listmatching/action/get_inventory", request)
					.then(response => {
						console.log(response.data)
						let stocks = response.data;
						stocks.forEach(data => {
							if (data.stock) {
								data.stock.vendor = this.vendors.find(v => v.id == Math.max(1, data.stock.vendorId))
							}
						});

						const mappedStocks = stocks.map(data => {
							return {
								Barcode: data.barcode,
								"EK-Preis": data.stock ? parseFloat(data.stock.purchasePrice) : null,
								"EK-Summe": data.stock ? parseFloat(data.stock.purchasePrice) + parseFloat(data.stock?.vendorShippingFee) : null,
								Lieferant: data.stock ? data.stock?.vendor.name : null,
								"Artikel-ID": data.stock?.articleId,
								Lagerbestand: data.stock ? parseInt(data.stock.quantity) : null,
								Eingangsporto: data.stock ? parseFloat(data.stock.vendorShippingFee) : null,
							}
						})


						//Ein Teil des Dateinamen für die jeweilige Funktion
						let operationTypeName = '';
						switch (this.select.listType) {
							case "inventoryByEan"                  :
								operationTypeName = 'Inventory_LF-EAN';
								break;
							case "inventoryByEanUsed"              :
								operationTypeName = 'Inventory_LF-EAN_Used';
								break;
							case "inventoryByEanSelectVendor"      :
								operationTypeName = 'Inventory_LF_Auswahl_EAN';
								break;
							case "inventoryByEanUsedSelectVendor"  :
								operationTypeName = 'Inventory_LF_Auswahl_EA_Used';
								break;
							default:
								break;
						}
						let sortedStocks = [];
						if (vendorIds.length > 0) {
							sortedStocks = this.sortData(vendorIdBarcodePair, mappedStocks, 'Barcode')
						} else {
							sortedStocks = this.sortData(extractedBarcodes, mappedStocks, 'Barcode')
						}
						this.generateExcelFile(sortedStocks, operationTypeName)
						this.queryInProgress = false;
					})
					.catch(error => {
						this.showError(error)
						console.error(error);
						this.queryInProgress = false;
					});
		},

		//articleCondition -- true = new / false = used / null = all
		//onStock -- true = only stock.quantity > 0 / false = only stock.quantity = 0 / null quantity does not matter
		//vendorSelected -- true if vendor(s) were selected / false for tab-divided VendorId and Ean
		//allVendors -- if a list type requires the inventory of all vendors
		submitAction_getCheapestStock(articleCondition, onStock, vendorsSelected, allVendors) {
			const barcodes = this.extractIds()
			let vendorIds = [];
			const extractedBarcodes = [];
			if (allVendors === true) {
				vendorIds = this.vendors.filter(vendor => vendor.id !== 99 && vendor.id !== 199 && vendor.id !== 10000).map(vendor => {
					return vendor.id
				})
				vendorIds = vendorIds.sort((a, b) => a - b);
			} else {
				//cloneDeep because then its just a reference and selectedVendors shows subvendors
				vendorIds = _.cloneDeep(this.selectedVendors);
				vendorIds.forEach(id => {
					let tempIds = this.vendors.filter(vendor => vendor.mainVendorId === id).map(vendor => {
						return vendor.id
					});
					tempIds.forEach(tempId => {
						vendorIds.push(tempId);
					})
				})
				vendorIds = vendorIds.sort((a, b) => a - b);
			}

			//convert the Article condition
			if (articleCondition === true) {
				articleCondition = 1;
			} else if (articleCondition === false) {
				articleCondition = 2;
			} else {
				articleCondition = null;
			}

			let request = {
				barcodes: barcodes,
				vendorIds: vendorIds,
				articleCondition: articleCondition,
				onStock: onStock,
			}

			this.queryInProgress = true;
			axios.post("/listmatching/action/cheapest_stock", request)
					.then(response => {
						// console.log(response.data)
						let stocks = response.data;
						stocks.forEach(data => {
							if (data.stock) {
								data.stock.vendor = this.vendors.find(v => v.id == Math.max(1, data.stock.vendorId))
							}
						});

						const mappedStocks = stocks.map(data => {
							return {
								Barcode: data.barcode,
								"EK-Preis": data.stock ? parseFloat(data.stock.purchasePrice) : null,
								"EK-Summe": data.stock ? parseFloat(data.stock.purchasePrice) + parseFloat(data.stock?.vendorShippingFee) : null,
								Lieferant: data.stock ? data.stock?.vendor.name : null,
								"Artikel-ID": data.stock?.articleId,
								Lagerbestand: data.stock ? parseInt(data.stock.quantity) : null,
								Eingangsporto: data.stock ? parseFloat(data.stock.vendorShippingFee) : null,
							}
						})


						//Ein Teil des Dateinamen für die jeweilige Funktion
						let operationTypeName = '';
						switch (this.select.listType) {
							case "cheapestWithStock"               :
								operationTypeName = 'Günstigster_mit_Bestand';
								break;
							case "cheapestWithStock_AllVendors"    :
								operationTypeName = 'Günstigster_mit_Bestand';
								break;
							case "cheapestWithoutStock"            :
								operationTypeName = 'Günstigster_ohne_Bestand';
								break;
							case "cheapestWithoutStock_AllVendors" :
								operationTypeName = 'Günstigster_ohne_Bestand';
								break;
							default:
								break;
						}

						let sortedStocks = [];
						if (vendorIds.length > 0) {
							sortedStocks = this.sortData(barcodes, mappedStocks, 'Barcode')
						} else {
							sortedStocks = this.sortData(barcodes, mappedStocks, 'Barcode')
						}
						this.generateExcelFile(sortedStocks, operationTypeName)
						this.queryInProgress = false;
					})
					.catch(error => {
						this.showError(error)
						console.error(error);
						this.queryInProgress = false;
					});
		},

		submitAction_getLastSellingPrice() {
			this.queryInProgress = true;
			const extractedBarcodes = this.extractIds();

			const req = {
				barcodes: extractedBarcodes,
				vendors: this.selectedVendors
			}
			axios.post('listmatching/action/last_selling_price', req)
					.then(res => {
						// console.log(res);
						const requestedData = res.data

						const mappedData = requestedData.map(data => {
							return {
								Barcode: data.barcode,
								"VK-Preis €": data.customerOrder ? (Number(data.customerOrder?.articlePriceClear) * Number(data.customerOrder?.currencyToEuro)).toFixed(2) : null,
								KaufDatum: data.customerOrder?.orderTime,
								SKU: data.customerOrder?.sku,
								"Bestell-Nr.": data.customerOrder?.marketOrderId,
								Artikelname: data.customerOrder?.articleTitle,
							}
						})
						const sortedData = this.sortData(extractedBarcodes, mappedData, 'Barcode')
						this.generateExcelFile(sortedData, 'Letzter_VK-Preis');
						this.queryInProgress = false;
					})
					.catch(error => {
						console.log(error);
						this.queryInProgress = false;
						this.showError(error)
					});
		},

		submitAction_getShippingWeight(_isEan = true) {
			const extractedBarcodes = this.extractIds();

			const params = {
				barcodes: extractedBarcodes,
				isEan: _isEan,
			}
			this.queryInProgress = true;
			axios.post('listmatching/action/get_shipping_weight', params)
					.then(res => {
						// console.log(res.data);
						//with this the order of columns is dynamically set
						let keyToSort = null;
						let keyNotToSort = null;
						if (_isEan) {
							keyToSort = 'EAN';
							keyNotToSort = 'ASIN';
						} else {
							keyToSort = 'ASIN';
							keyNotToSort = 'EAN';
						}

						const mappedMaterials = res.data.map(material => {
							return {
								[keyToSort]: _isEan === true ? material.ean : material.asin,
								[keyNotToSort]: _isEan ? material.materialData?.asin : material.materialData?.ean,
								MaterialId: material.materialData?.id,
								"Gewicht [KG]": material.materialData?.product ? (material.materialData.product.shippingWeight / 1000) : '',
								Kategorie: material.materialData?.product ? this.getCategoryName(material.materialData.product.category) : '',
								Produktname: material.materialData?.product ? material.materialData.product.name : '',

							}
						});
						// console.log(mappedMaterials);
						let sortedMaterial = [];
						if (_isEan) {
							sortedMaterial = this.sortData(extractedBarcodes, mappedMaterials, keyToSort)
						} else {
							sortedMaterial = this.sortData(extractedBarcodes, mappedMaterials, keyToSort)
						}
						this.generateExcelFile(sortedMaterial, 'LA-Gewicht')
						this.queryInProgress = false;
					})
					.catch(error => {
						console.log(error);
						this.queryInProgress = false;
						this.showError(error)
					});
		},

		submitAction_quantityOfSales() {
			const extractedBarcodes = this.extractIds()
			let vendorIds = [];

			if (this.selectedVendors.length !== 0) {

				vendorIds = _.cloneDeep(this.selectedVendors);
				vendorIds.forEach(id => {
					let tempIds = this.vendors.filter(vendor => vendor.mainVendorId === id).map(vendor => {
						return vendor.id
					});
					tempIds.forEach(tempId => {
						vendorIds.push(tempId);
					})
				})
				vendorIds = vendorIds.sort((a, b) => a - b);
			}

			let request = {
				vendorIds: vendorIds,
				barcodes: extractedBarcodes,
				dateFrom: this.dateFrom,
				dateTo: this.dateTo,
			}
			// console.log(request);
			this.queryInProgress = true;
			axios.post('listmatching/action/quantity_of_sales', request).then(response => {
				// console.log(response.data);

				const mappedstocks = response.data.map(stock => {
					return {
						EAN: stock[0].barcode,
						Name: stock[0].materialName,
						MaterialId: stock[0].materialId,
						"Verkaufshäufigkeit": stock[0].salesCount,
						Artikelnummer: stock[0].articleId,
						Lieferant: stock[0].bestStock?.vendor.name,
						SKU: stock[0].bestStock?.sku,
						purchasePrice: stock[0].bestStock?.purchasePrice,
						"Lagerbestand": stock[0].bestStock?.quantity,
						InStockSince: stock[0].bestStock?.inStockSince,
						lastUpdateTime: stock[0].bestStock?.lastUpdateTime,
						lastUpdateUser: stock[0].bestStock?.lastUpdateUser,
						lastUpdateReason: stock[0].bestStock?.lastUpdateReason,
						"letzter Verkauf": stock[0].lastSale,

					}
				})
				const sortedStocks = this.sortData(extractedBarcodes, mappedstocks, 'EAN');
				this.generateExcelFile(sortedStocks, 'Verkaufshäufigkeit');
				this.queryInProgress = false;
			}).catch(error => {
				console.error(error);
				this.queryInProgress = false;
				this.showError(error)
			});
		},

		submitAction_ReturnApplication(){
			const extractedBarcodes = [];
			const barcodeAndQuantityPair = [];
			for (const row of this.extractIds()) {
				let dump = row.split("\t");
				if (dump == "") continue;
				if (dump.length !== 2) {
					alert("Ean und Menge muessen in jeder Zeile durch ein Tab-Zeichen getrennt werden. Fehlerhafte Zeile: \"" + row + "\"");
					return;
				}

				if (isNaN(dump[0])) {
					alert("Die Datenliste enthaelt einen Eintrag, wo der EAN keine Zahl ist:" + dump[0]);
					return;
				}
				if (isNaN(dump[1])) {
					alert("Ihre Datenliste enthaelt einen Eintrag, wo die keine Zahl ist." + dump[1]);
					return;
				}
				extractedBarcodes.push(dump[0]);

				barcodeAndQuantityPair.push({
					barcode: dump[0],
					quantity: dump[1]
				})
			}

			const request = {
				eanAndQuantityPair: barcodeAndQuantityPair,
				vendorId: this.selectedVendors[0],
				storageVendorIds: this.selectedStorageVendors,
				dateFrom: this.dateFrom,
			}
			console.log("request");
			console.log(request);
			this.queryInProgress = true;
			axios.post("/listmatching/action/return_application", request)
					.then(response => {
						console.log("response.data");
						console.log(response.data);

						const sortedIds = extractedBarcodes.map(barcode => {
							const match = response.data?.find(data => data.material?.originalEan === barcode);
							return match ? match.material.ean : barcode;
							})
							.filter(id => id !== null);

						let mappedReturnRequestData = response.data.map(data => {
							return {
								Ean: data?.material?.ean,
								"Name": data?.material?.product?.name,
								"EK in Euro": data?.purchasePrice,
								"Verkaufshäufigkeit.": data?.salesCount,
								deliveryNotes: data?.deliveryNotes
							}
						})

						mappedReturnRequestData = mappedReturnRequestData.map(data => {
							if(!data.deliveryNotes) return data;
							data.deliveryNotes.forEach(((dn, index) => {
								data[`Rechung_${index+1}`] =  `RE_Number: ${dn.dnNumber} - RE_Menge: ${dn.quantity} - RE_Datum: ${moment(dn.dnDate).format("DD-MM-YYYY")} - Dateiname: ${dn.fileName}`;
							}))
							delete data.deliveryNotes;
							return data;
						})
						console.log("sortedIds")
						console.log(sortedIds)
						console.log("extractedBarcodes")
						console.log(extractedBarcodes)

						const sortedReturnRequestData = this.sortData(sortedIds.length > 1 ? sortedIds : extractedBarcodes, mappedReturnRequestData, 'Ean');
						this.generateExcelFile(sortedReturnRequestData, 'Retourenantrag');
						this.queryInProgress = false;
					}).catch(error => {
				this.showError(error)
				console.error(error);
				this.queryInProgress = false;
			});
		},

		getCategoryName(category) {
			switch (category) {
				case 1:
					return "Music";
				case 2:
					return "Movie";
				case 3:
					return "Book";
				case 4:
					return "Toy";
				case 5:
					return "Game";
				case 6:
					return "Other";
				case 7:
					return "Kleidung";
				case 8:
					return "Beauty";
				case 9:
					return "Auto";
				case 10:
					return "Elektronik";
				case 11:
					return "Schmuck";
				case 12:
					return "Küche & Haus";
				case 13:
					return "Office";
				case 14:
					return "Haustierzubehör";
				default:
					return "Unknown";
			}
		},

		getHSCode(category) {
			switch (category) {
				case 1:
					return "852380";
				case 2:
					return "852349";
				case 3:
					return "490199";
				case 4:
					return "950300";
				case 5:
					return "950430";
				case 6:
					return "392690";
				case 7:
					return "610990";
				case 8:
					return "330410";
				case 9:
					return "340530";
				case 10:
					return "854370";
				case 11:
					return "711790";
				case 12:
					return "821599";
				case 13:
					return "392610";
				case 14:
					return "420100";
				default:
					return "000000";
			}
		},

		generateExcelFile(mappedData, fileName) {
			let currentDate = moment().format("DD.MM.YYYY");
			Vue.nextTick().then(() => {
				const ws = XLSX.utils.json_to_sheet(mappedData);
				const wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws);
				XLSX.writeFile(wb, fileName + '-' + currentDate + ".xlsx");
			})
		},

		showError(error) {
			this.modalError = {
				show: true,
				message: "Operation konnte nicht durgeführt werden.",
				error: error,
				title: "Ein Fehler ist aufgetreten"
			};
		},

		sortData(idsArray, dataArray, keyToSort, additionalIds = null) {
			let sortedArray = [];
			idsArray.forEach(id => {
				let maybe = dataArray.find(data => id == data[keyToSort]);

				if (!maybe && additionalIds != null) {
					const currentMaterialId = Object.entries(additionalIds).find(([key]) => key === id);

					maybe = dataArray.find(data => currentMaterialId?.[1] == data?.materialId || currentMaterialId?.[1] == data?.id)

				}
				if (!maybe) {
					maybe = {
						[keyToSort]: id
					}
				}

				sortedArray.push(maybe);
			});

			return sortedArray;
		},

		extractIds() {
			return this.select.barcodes.split('\n').map(s => s.replaceAll("'", '').trim())
		},
		//maps the CustomerOrders for MarketOrderId/ShippingId
		mapCustomerOrderData(customerOrders) {
			return customerOrders.map(customerOrder => {

				customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = null;
				customerOrder.isVendorChange = false;
				customerOrder.isReorder = false;
				// console.log("+++ called compileCustomerOrder");
				for (let h of customerOrder.customerorderhistories) {
					if ((h.lastUpdateReason && h.lastUpdateReason.includes('Delivery Job'))
							&& (customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime == null
									|| customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime > null)) {
						customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = h.lastUpdateTime; // aka Meldedatum
					}
					customerOrder.isVendorChange = customerOrder.isVendorChange || (h.comment && h.comment.includes("Umbestellung"));
					customerOrder.isReorder = customerOrder.isReorder || (h.comment && h.comment.includes("Neubestellung"));

				}
				//if, by chance, the Marketplace is Priceminister (3) and no 'Delivery Job' History exists, just use the COID.submissionTime
				if (['0000-00-00 00:00:00', '1999-11-30 00:00:00', '', null, undefined].includes(customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime)
						&& customerOrder.marketAccountId == 3 /*DANGER*/) {
					//marvelous, truly
					customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = customerOrder.customerorderitems[0]
							.customerorderitemdeliveries[0]
							.deliverySubmissionTime;
				}

				let tracking = "";
				if (customerOrder.customerorderitems[0]?.customerorderitemdeliveryaddition) {
					tracking = customerOrder.customerorderitems[0]?.customerorderitemdeliveryaddition?.shippingId
				}

				return {
					CustomerOrderID: customerOrder.id,
					Marketaccount: customerOrder.marketaccount.name,
					Kaufdatum: customerOrder.paymentDate,
					SKU: customerOrder.customerorderitems[0]?.stock.sku,
					EAN: customerOrder.customerorderitems[0]?.stock.material.ean,
					"Bestell-ID": customerOrder.marketOrderId,
					MarketOrderItemID: customerOrder.customerorderitems[0]?.marketOrderItemId,
					Vorversanddatum: customerOrder.lastUpdateTime,
					Meldedatum: customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime,
					Versanddatum: customerOrder.deliveryDate,
					Kategorie: this.getCategoryName(customerOrder.customerorderitems[0]?.product.category),
					Artikelname: customerOrder.customerorderitems[0]?.product.name,
					Anzahl: customerOrder.customerorderitems[0]?.quantity,
					Gesamtpreis: customerOrder.customerorderitems[0]?.articlePriceGross,
					Empfaengername: `${customerOrder.address.firstname == undefined ? "" : customerOrder.address.firstname} ${customerOrder.address.lastName}`,
					"Kunden-Email": customerOrder.address.email,
					Adresse1: customerOrder.address.street,
					Adresse2: customerOrder.address.street2,
					Stadt: customerOrder.address.city,
					PLZ: customerOrder.address.zipCode,
					Staat: customerOrder.address.state,
					Land: customerOrder.address.country.countryName,
					Sendungsnummer: tracking,
					Gesamtartikelpreis: customerOrder.customerorderitems[0]?.articlePriceClear,
					HScode: this.getHSCode(customerOrder.customerorderitems[0]?.product.category),
					ArtikelGewicht: customerOrder.customerorderitems[0]?.product.baseWeight,
				}
			})
		}
	},

	created() {
		this.getAllVendors();
	}
};
</script>
